<template>
  <div>
    <base-page-heading title="Commission Report" />
    <div class="content">
      <report-list-filter
        class="mb-0"
        :columns="columns"
        :initial-filters="filters"
        @filters-applied="applyFilters"
      />
      <report-table
        class="mt-3"
        :filters="filters"
        :columns="columns"
        v-bind="{ ...sorting, ...pagination }"
      />
    </div>
  </div>
</template>

<script>
import listMixin from '@/mixins/listMixin';
import { DateTime } from 'luxon';
import {
  COMMISSION_REPORT_TABLE_NAME,
} from '@/constants/reports';
import ReportListFilter from '@/components/admin/reports/commissions/ReportListFilter.vue';
import ReportTable from '@/components/admin/reports/commissions/ReportTable.vue';

export default {
  name: 'CommissionsReport',
  components: {
    ReportTable,
    ReportListFilter,
  },
  mixins: [listMixin],
  props: {
    client_id: String,
    location_id: String,
    service_id: String,
    commission_plan_id: String,
    user_id: String,
    start_date: String,
    end_date: String,
  },
  data() {
    const lastSixMonthsStart = DateTime.now().minus({ month: 6 }).startOf('month').toISODate();
    const lastSixMonthsEnd = DateTime.now().toISODate();

    return {
      tableName: COMMISSION_REPORT_TABLE_NAME,
      filters: {
        client_id: this.client_id || this.$store.getters?.client?.id,
        location_id: this.location_id,
        service_id: this.service_id,
        commission_plan_id: this.commission_plan_id,
        user_id: this.user_id,
        start_date: this.start_date || this.$options.filters.dateFormat(lastSixMonthsStart),
        end_date: this.end_date || this.$options.filters.dateFormat(lastSixMonthsEnd),
      },
    };
  }
};
</script>
